import axios from "axios";
import {iMapSummary} from "../maps/map_components";
import qs from "qs";



export const STRAPI_ROOT = 'https://cms.statuscode200.com';

export const STRAPI_API = `${STRAPI_ROOT}/api`;

const STRAPI_NOTES_ENDPOINT = `${STRAPI_API}/notes`;
export const STRAPI_NOTES_ALL = STRAPI_NOTES_ENDPOINT + '?sort=updatedAt:desc'
export const STRAPI_NOTES_ONE = (id: string) => `${STRAPI_NOTES_ENDPOINT}?filters[Slug][$eq]=${id}`;


export const STRAPI_PROGRESS_ENDPOINT = `${STRAPI_API}/progresses`;

export const STRAPI_MAPS = `${STRAPI_API}/maps`;
export const STRAPI_MAPS_ONE =  (id: string) => `${STRAPI_MAPS}?populate=code.js,code.css,title&filters[url][$eq]=${id}`;

export const STRAPI_ARTICLES = `articles`;
export const STRAPI_ARTICLES_ALL = `${STRAPI_API}/${STRAPI_ARTICLES}?populate=*&sort=updatedAt:desc&filters[state][$in][0]=public&filters[state][$in][1]=featured`;
export const STRAPI_ARTICLES_FEATURED = `${STRAPI_API}/${STRAPI_ARTICLES}?populate=*&sort=updatedAt:desc&filters[state][$in][1]=featured`;

export const STRAPI_ABOUT = `about`;
export const STRAPI_HOME = `home`;
export const STRAPI_HOME_TOP = `home-top`;


export function getNotes() {

    fetch('')


}

interface iStrapiMap {
    title: string;
    description: string;
    createdAt: Date;
    updatedAt: Date;
    featured: boolean;
    url: string;
    thumbnailUrl: string
}


export const getMaps = (onlyFeatured: boolean = false, limit: number = 0): Promise<iStrapiMap[]> => {


    return new Promise((resolve, reject) => {

        let requestUrl = `${STRAPI_MAPS}?populate[0]=Image&sort=updatedAt:desc`;

        requestUrl += '&filters[State][$in][0]=featured';
        //
        if (!onlyFeatured) {
            requestUrl += '&filters[State][$in][1]=public'
        }
        //
        if (limit > 0) {
            requestUrl += `&pagination[pageSize]=${limit}`
        }

        // console.log(requestUrl);
        axios.get(requestUrl).then((d) => {
            // console.log(d);




            const mapSummaryArray: iStrapiMap[] = [];
            for (let m of d['data']['data']) {
                let mAttr = m;



                mapSummaryArray.push({
                    title: mAttr['Title'],
                    description: mAttr['Description'],
                    createdAt: new Date(mAttr['createdAt']),
                    updatedAt: new Date(mAttr['updatedAt']),
                    featured: mAttr['State'] === 'Featured',
                    url: mAttr['Url'],
                    thumbnailUrl: `${STRAPI_ROOT}${mAttr['Image']['url']}`
                })
            }

            resolve(mapSummaryArray);

        }).catch((e) => {
            reject(e);
        })
    });
}

export interface strapiGetOptions {
    slug?: string;
    populate?: string[]
}


export function getDynamicZoneQuery(path: string, options?: strapiGetOptions) {

    if (!options) {
        options = {
            populate: [],
        }
    }

    const populate: { [key: string]: any} = {
                    content: {
                        on: {
                            'shared.rich-text': {
                                populate: '*',
                            },
                            'shared.media': {
                                populate: 'file',
                            },
                            'shared.gallery': {
                                populate: {
                                    image: {
                                        populate: '*',
                                    }
                                }
                            },
                        },
                    },
                };


    if (options.populate) {
        for (let p of options.populate) {
            populate[p] = {
                populate: '*',
            }
        }
    }


    const query = qs.stringify(
            {
                populate: populate,
            },
            {encodeValuesOnly: true}
        );

    let url_query = `${STRAPI_API}/${path}?${query}`


    if (options.slug){
        url_query += `&filters[slug][$eq]=${options.slug}`

    }

    return url_query;
}
